<div class="{{ white ? 'white' : '' }} accordion">
  <div class="upper" (click)="onToggleView()">
    <div class="title">
      <h5>{{ title }}</h5>
    </div>
    <fa-icon [icon]="accordionOpen ? faChevronUp : faChevronDown"></fa-icon>
    <!--  -->
  </div>
  <div
    class="text {{ accordionOpen ? 'open' : '' }}"
    [innerHTML]="safeHtml"
  ></div>
</div>
